import React from 'react';
import { Input, CheckboxWithInput, Section } from '../Shared';
import { CITING_SECTION_TITLE, FEDERAL_RULE_CITING_SECTION_ID, FEDERAL_RULE_CITING_SECTION_TEST_ID, FEDERAL_RULE_LABEL_TEXT, FEDERAL_RULE_LABEL_TEXT_BOLD, FEDERAL_RULE_MULTIPLE_SECTIONS_FIELD_CHECKBOX_TEST_ID, FEDERAL_RULE_MULTIPLE_SECTIONS_FIELD_TEST_ID, FEDERAL_RULE_SECTION_FIELD_TEST_ID, FEDERAL_RULE_TITLE_FIELD_TEST_ID, SECTION, TITLE } from './constants';
import { CheckBoxGroupWithInput, CheckBoxLabel } from '../GenericSection/styled';
export var FederalRuleCitingSection = function FederalRuleCitingSection() {
  return /*#__PURE__*/React.createElement(Section, {
    sectionId: FEDERAL_RULE_CITING_SECTION_ID,
    title: CITING_SECTION_TITLE,
    ariaLabelledby: "".concat(FEDERAL_RULE_CITING_SECTION_ID, "-label"),
    dataTestId: FEDERAL_RULE_CITING_SECTION_TEST_ID
  }, /*#__PURE__*/React.createElement(Input, {
    name: "fedrule.title",
    labelText: TITLE,
    "data-test": FEDERAL_RULE_TITLE_FIELD_TEST_ID
  }), /*#__PURE__*/React.createElement(Input, {
    name: "fedrule.section",
    labelText: SECTION,
    "data-test": FEDERAL_RULE_SECTION_FIELD_TEST_ID
  }), /*#__PURE__*/React.createElement(CheckBoxGroupWithInput, {
    "data-test": FEDERAL_RULE_MULTIPLE_SECTIONS_FIELD_TEST_ID
  }, /*#__PURE__*/React.createElement(CheckBoxLabel, null, FEDERAL_RULE_LABEL_TEXT_BOLD), /*#__PURE__*/React.createElement(CheckboxWithInput, {
    name: "fedrule.sectionplus",
    inputId: "fedrule.sectionplus.field",
    "data-test": FEDERAL_RULE_MULTIPLE_SECTIONS_FIELD_CHECKBOX_TEST_ID,
    input: "et seq"
  }, FEDERAL_RULE_LABEL_TEXT)));
};